export default {
  all: 'All',
  premium: 'Premium',
  basic: 'Basic',
  trial: 'Trial',
  purchaser: 'Purchaser',
}
